import axios from 'axios';
// import store from "../store/index"
import { Message } from 'element-ui';
// 进行一些全局配置
// axios.defaults.baseURL = '/red-star-api';
axios.defaults.baseURL = '/website-api';
// axios.defaults.baseURL = '/red-star-api'
(axios.defaults.headers = { 'Content-Type': 'application/json' }),
  (axios.defaults.timeout = 30000);
// 添加请求拦截器
// const { commit}=store
axios.interceptors.request.use(
  function(config) {
    const { params = {} } = config;
    config.params = { ...params };
    config.headers = {
      ...(config.headers || {})
      // 'X-Auth-Token': 'debug'
    };
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

// 添加响应拦截器
axios.interceptors.response.use(
  function(response) {
    if (!response.data.errorCode) {
      return Promise.resolve(response);
    }
    if (response.data.errorCode === 10000) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response.data);
    }
  }
  // function (error) {
  //   Notification.error(error);
  //   return Promise.reject(error);
  // }
);
export function downloadFile(url) {
  return axios
    .get(url, { responseType: 'blob' })
    .then(res => Promise.resolve(res.data));
}
// 保存下载文件
function saveFile(binaryData, fileName, mime) {
  const fileDownload = require('js-file-download');
  fileDownload(binaryData, fileName, mime);
}
export default {
  download: function(path, config) {
    const { filename = 'temp', mime = '' } = config || {};
    return axios.get(path, { ...config, responseType: 'blob' }).then(res => {
      saveFile(res.data, filename, mime);
      return Promise.resolve(res);
    });
  },
  get: function(path = '', data = {}) {
    return new Promise(function(resolve, reject) {
      axios
        .get(path, {
          params: data
        })
        .then(function(response) {
          resolve(response.data);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  post: function(path = '', data = {}, config = {}) {
    return new Promise(function(resolve, reject) {
      if (config['Content-Type']) {
        axios.defaults.headers = { ...axios.defaults.headers, ...config };
      } else {
        axios.defaults.headers = {
          ...axios.defaults.headers,
          'Content-Type': 'application/json'
        };
      }
      // commit('setLaoutLoading',true)
      axios
        .post(path, data)
        .then(function(response) {
          resolve(response.data);
        })
        .catch(function(error) {
          Message.error({
            message: error.errorMsg
          });
          reject(error);
        })
        .finally(() => {
          // commit('setLaoutLoading',false)
        });
    });
  },
  all: function(list) {
    return new Promise(function(resolve, reject) {
      // commit('setLaoutLoading',true)
      axios
        .all(list)
        .then(
          axios.spread(function(...result) {
            // 两个请求现在都执行完成
            resolve(result);
          })
        )
        .catch(function(err) {
          Message.error({
            message: err.errorMsg
          });
          // window._vm.$message.error(err.errorMsg);
          reject(err);
        })
        .finally(() => {
          // commit('setLaoutLoading',false)
        });
    });
  }
};
